import {PageHeader} from '../index';
import React from 'react';

export default function MyClientsPageHeader () {
  return (
    <PageHeader title='My Clients' height='119px' />
  );
}